'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDeviceDetect = require('react-device-detect');

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Support = function (_React$Component) {
    _inherits(Support, _React$Component);

    function Support() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, Support);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Support.__proto__ || Object.getPrototypeOf(Support)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-8',
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            companyName: 'Beijing Xiaowei Cloud Inc.',
            contantUsEmail: 'service@xiaoweiyunfu.com'
        }, _this2.renderContent = function () {

            if (_reactDeviceDetect.isMobile) {
                return _this2.renderPhone();
            }

            var local = _Locale2["default"].GetInstance();
            var title = local.getMessagebyId('www_title');
            var support = local.getMessagebyId('support');
            var contact = local.getMessagebyId('support_text1');

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            title
                        )
                    )
                ),
                _react2["default"].createElement('div', { className: 'eula' }),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    support
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    contact,
                                    _this2.state.contantUsEmail
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'left' })
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023 ',
                            _this2.state.companyEnName,
                            '  \xA0\xA0 ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicyen' },
                                'Privacy Policy'
                            ),
                            ' '
                        )
                    )
                )
            );
        }, _this2.renderPhone = function () {

            var local = _Locale2["default"].GetInstance();
            var title = local.getMessagebyId('www_title');
            var support = local.getMessagebyId('support');
            var contact = local.getMessagebyId('support_text1');

            return _react2["default"].createElement(
                'div',
                { className: 'phone' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            title
                        )
                    )
                ),
                _react2["default"].createElement('div', { className: 'eula' }),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    support
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    contact,
                                    _this2.state.contantUsEmail
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023 ',
                            _this2.state.companyEnName,
                            '  '
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(Support, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }
            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('support_title');

            this.GetContantUs();
        }
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return this.renderContent();
        }
    }]);

    return Support;
}(_react2["default"].Component);

exports["default"] = Support;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Support.js
// module id = 389
// module chunks = 0